import { action } from "satcheljs";

const refreshSchedule = action(
    "REFRESH_SCHEDULE", () => ({ })
);

export default refreshSchedule;